import { render, staticRenderFns } from "./infoStatistics.vue?vue&type=template&id=5025db86"
import script from "./infoStatistics.vue?vue&type=script&lang=js"
export * from "./infoStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports